var React = require('react');

function User (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M19.9995 0.751099C9.60921 0.751099 0.832794 9.52752 0.832794 19.9178C0.832794 30.308 9.60921 39.0844 19.9995 39.0844C30.3897 39.0844 39.1661 30.308 39.1661 19.9178C39.1661 9.52752 30.3897 0.751099 19.9995 0.751099ZM19.9995 10.3344C23.3095 10.3344 25.7495 12.7724 25.7495 16.0844C25.7495 19.3964 23.3095 21.8344 19.9995 21.8344C16.6913 21.8344 14.2495 19.3964 14.2495 16.0844C14.2495 12.7724 16.6913 10.3344 19.9995 10.3344ZM10.213 29.0641C11.9322 26.5341 14.7995 24.8474 18.0828 24.8474H21.9161C25.2013 24.8474 28.0667 26.5341 29.786 29.0641C27.3365 31.6861 23.8615 33.3344 19.9995 33.3344C16.1374 33.3344 12.6625 31.6861 10.213 29.0641Z","fill":"white","fillOpacity":"0.8"}));
}

User.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = User;

User.default = User;
